import {Component, computed, input} from '@angular/core';

const ICONS = {
    info: 'circle-info',
    warn: 'circle-pause',
    error: 'triangle-exclamation',
};

/**
 * Full width banner: icon + bold title + text, with optional actions on the right
 * (project buttons with the `actions` attribute, e.g. `<button actions mat-stroked-button>`).
 */
@Component({
    selector: 'app-info-banner',
    templateUrl: './info-banner.component.html',
    styleUrl: './info-banner.component.scss',
    host: {
        '[class]': '"tone-" + tone()',
        'role': 'status',
        // `title` is an input; keep the browser from showing it as a tooltip on the whole element
        '[attr.title]': 'null'
    }
})
export class InfoBannerComponent {
    readonly tone = input<'info' | 'warn' | 'error'>('info');
    readonly title = input<string>();
    readonly icon = input<string>();
    readonly defaultIcon = computed(() => ICONS[this.tone()]);
}
